// Repair estimates (Session SC7A): the Repairs hub's third tab, every estimate in one place, 50 at a time, newest first, filtered by
// status. It is the same panel the Defect, Call-out and Customer pages mount, in "every estimate" mode, so each row carries the same actions
// (send the letter or the repair quotation as a Gmail draft, record the customer's answer, raise or attach the job, delete) and nothing
// forks. An estimate is raised from the fault it prices (the To fix tab), a call-out or a customer; this tab is where they are all kept.
import { PageHeader } from "../../components/PageHeader";
import { RepairEstimatesPanel } from "./RepairEstimatesPanel";

export function RepairEstimatesListPage() {
  return (
    <div>
      <PageHeader
        className="mb-4"
        title="Repair estimates"
        subtitle="Every repair price put to a customer, whatever it was raised from. Nothing is sent from here: each send makes a draft in Gmail for you to review and send. An estimate is raised from the fault it prices, on the To fix tab, or from a call-out or a customer."
      />
      <RepairEstimatesPanel listAll className="rounded-ele border border-ele-purple-accent bg-ele-surface p-5" />
    </div>
  );
}
